import { Tag, TagProps } from "@carbon/react";
import React from "react";

import { useGetAlertStatusLabel } from "src/hooks/alerts/useGetAlertStatusLabel";
import { AlertStatus } from "src/types/alert";

const ALERT_STATUS_COLORS: Record<AlertStatus, TagProps<"div">["type"]> = {
  closed: "green",
  notAssigned: "gray",
  assigned: "blue",
  canceled: "cool-gray",
};

export const AlertStatusTag: React.FC<{ status: AlertStatus }> = ({ status }) => {
  const getAlertStatusLabel = useGetAlertStatusLabel();
  return <Tag type={ALERT_STATUS_COLORS[status]}>{getAlertStatusLabel(status)}</Tag>;
};
